function LogoVidalink(props: any) {
  return (
    <svg
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 287.5 46"
      xmlSpace="preserve"
      {...props}
    >
      <style>
        {
          ".st0{fill:none}.st1{fill:#bcc942}.st2{fill:#ea9202}.st4{fill:#e75212}.st5{fill:#e31719}.st9{fill:#038b9b}.st10{fill:#434e9b}.st12{fill:#9b9a21}.st13{fill:#3ca647}.st14{fill:#5eb4ac}"
        }
      </style>
      <path className="st0" d="M69.88 29.76c-.08.13-.16.27-.24.41l.04.08.2-.49z" />
      <path className="st0" d="M79.3 40.49L78 38.06 79.28 40.48z" />
      <path className="st0" d="M73.61 37.85L75.78 38.82 73.61 37.85z" />
      <path className="st0" d="M72.09 5.09L72.08 5.09 76.38 6.54z" />
      <path
        className="st0"
        d="M72.67 19.26c0-.01.01-.02.01-.02.75-2.51 2.08-7.02 2.08-7.02l-2.09 7.04z"
      />
      <path
        className="st1"
        d="M7.35 10.75c.58 0 1.18.09 1.78.25L5.28 1.62C3.32 2.33 1.94 4.02 1.94 6c0 2.62 2.42 4.75 5.41 4.75z"
      />
      <path
        className="st2"
        d="M9.63 11.16l-.8-9.85c-.5-.04-.99-.06-1.49-.06-.74 0-1.43.13-2.07.36L9.13 11c.17.05.34.1.5.16z"
      />
      <path
        d="M12.57 12.78l1.08-10.44a19.1 19.1 0 00-4.82-1.02l.8 9.85c.97.33 1.96.88 2.94 1.61z"
        fill="#ee7509"
      />
      <path
        className="st4"
        d="M36.44 16.58l-5.59-8.99c-3.07 2.87-5.86 6.69-8.3 11.38l10.13 3.38c1.18-2.2 2.45-4.14 3.76-5.77zM16.78 17.04l3.23 1.08c1.47-2.83 3.06-5.37 4.78-7.61-3.35-4-7.11-6.76-11.13-8.17l-1.08 10.44c1.41 1.05 2.83 2.49 4.2 4.26z"
      />
      <path
        className="st5"
        d="M33.9 25.76c-1.73 3.71-3.69 6.95-5.82 9.74 2.66 3.17 5.57 5.56 8.67 7.12l4.19-8.94c-2.4-1.59-4.83-4.32-7.04-7.92zM32.68 22.35l-10.13-3.38c-.33.64-.66 1.3-.98 1.97-1.1 2.36-2.29 4.48-3.54 6.33l6.08 9.01c2.77-3.11 5.27-7.04 7.44-11.72.37-.77.74-1.5 1.13-2.21zM50.41 33.48c-1.66 1.15-3.32 1.77-4.88 1.77-1.32 0-2.71-.45-4.11-1.28l-2.09 9.73c2.01.69 4.08 1.04 6.2 1.04 4.35 0 8.51-1.49 12.32-4.34l-7.44-6.92zM18.97 20.24c0-.02.01-.04.02-.06.33-.71.67-1.39 1.02-2.06l-3.23-1.08c.74.97 1.48 2.04 2.19 3.2z"
      />
      <path
        d="M15.56 30.47l4.61 9.55c1.36-1.07 2.68-2.32 3.94-3.74l-6.08-9.01a29.54 29.54 0 01-2.47 3.2z"
        fill="#cf2059"
      />
      <path
        d="M7.45 35.25l-3.55 8.4c.93.68 2.14 1.09 3.45 1.09 4.55 0 8.88-1.62 12.82-4.72l-4.61-9.55c-2.69 3.02-5.51 4.74-8.11 4.78z"
        fill="#a93a8d"
      />
      <path
        d="M7.35 35.25c-2.98 0-5.41 2.13-5.41 4.74 0 1.47.77 2.78 1.96 3.65l3.55-8.4c-.03.01-.07.01-.1.01z"
        fill="#6d3282"
      />
      <path
        className="st4"
        d="M73.61 37.85h-.01l-3.92-7.59-.04-.08c-.93 1.62-1.98 3.35-2.87 4.62l6.84 3.05zM68.24 27.54l-2.65-5.2-6.61.18c-1.33 2.65-2.8 4.96-4.32 6.85l9.7 4.34c1.38-1.84 2.67-3.9 3.88-6.17z"
      />
      <path
        className="st2"
        d="M44.61 10.82l.26-9.55c-5.03.17-9.78 2.34-14.02 6.32l5.59 8.99c2.68-3.32 5.53-5.37 8.17-5.76z"
      />
      <path
        className="st5"
        d="M69.68 30.26l3.92 7.59h.01l2.17.97 2.22-.76-6.67-10.87c-.39.7-.89 1.61-1.45 2.58l-.2.49z"
      />
      <path
        className="st9"
        d="M75.78 38.82l-1.85.63 1.34 3.32c1.99.96 4.06 1.57 6.19 1.83l-2.18-4.13-3.5-1.65z"
      />
      <path className="st10" d="M71.32 40.35c1.28.97 2.6 1.78 3.96 2.43l-1.34-3.32-2.62.89z" />
      <path
        className="st2"
        d="M64.36 33.71l-9.7-4.34c-1.39 1.73-2.82 3.12-4.25 4.11l7.43 6.92c2.31-1.73 4.5-3.97 6.52-6.69zM71.32 40.35l2.62-.89 1.85-.63-2.17-.97-6.84-3.06c-.18.25-.35.49-.51.7 1.59 1.89 3.28 3.52 5.05 4.85zM61.46 17.6c-.68 1.22-1.33 2.5-1.95 3.85-.17.36-.35.72-.53 1.07l6.61-.18-4.13-4.74zM50.9 12.88c2.15 1.63 4.29 4.15 6.25 7.36a58.24 58.24 0 012.48-4.73l-.99-1.14-7.74-1.49z"
      />
      <path
        d="M45.54 10.75c1.49 0 3.06.57 4.64 1.62l.94-6.61-.01-.01v-.02L45.8 1.26h-.27c-.22 0-.44.01-.66.02l-.26 9.55c.31-.06.62-.08.93-.08z"
        fill="#d7aa05"
      />
      <path className="st12" d="M51.12 5.75l-.94 6.61c.24.16.49.33.73.52l7.74 1.49-7.53-8.62z" />
      <path className="st1" d="M51.46 2.21c-1.84-.6-3.73-.92-5.65-.94l5.31 4.47.34-3.53z" />
      <path
        className="st13"
        d="M51.11 5.73v.01l.01.01 7.52 8.62.99 1.14c.69-1.19 1.41-2.31 2.16-3.37l-8.87-9.39c-.49-.2-.97-.38-1.46-.55l-.35 3.53zM70.86 22.32c.07-.12.13-.25.2-.38l-7.45-7.89a46.14 46.14 0 00-2.15 3.54l4.13 4.74 5.27-.01z"
      />
      <path
        className="st9"
        d="M72.67 19.26l2.09-7.04-5.91-1.99 1.08 8.23-4.77-6.58c-.53.69-1.04 1.42-1.55 2.18l7.45 7.89c.53-.95 1.06-1.85 1.61-2.69zM62.98 10.51c-3.05-3.64-6.44-6.25-10.06-7.76l8.87 9.39c.39-.56.79-1.11 1.19-1.63z"
      />
      <path
        className="st14"
        d="M72.69 19.24c1.63-2.49 3.36-4.5 5.1-5.94l-3.03-1.08s-1.33 4.5-2.07 7.02z"
      />
      <path
        className="st1"
        d="M74.76 12.22l3.03 1.08c2.01-1.65 4.02-2.55 5.92-2.55 1.17 0 2.25-.33 3.13-.88L76.38 6.54l-1.62 5.68z"
      />
      <path
        className="st13"
        d="M68.85 10.24l5.91 1.99 1.62-5.68-4.3-1.45c-1.21.84-2.39 1.82-3.53 2.93l.3 2.21z"
      />
      <path
        d="M89.05 5.29c-.39-2.28-2.63-4.03-5.34-4.03-2.07 0-4.09.34-6.05.99l-.87 2.91 12.26.13z"
        fill="#518255"
      />
      <path
        className="st14"
        d="M76.38 6.54l10.46 3.33c1.38-.86 2.27-2.27 2.27-3.87 0-.24-.02-.48-.06-.71l-12.26-.13-.41 1.38z"
      />
      <path
        className="st12"
        d="M65.59 22.33l2.65 5.2c.43-.8.84-1.62 1.25-2.48.44-.95.9-1.86 1.37-2.74l-5.27.02z"
      />
      <path
        className="st10"
        d="M68.85 10.24l-.29-2.21a36.01 36.01 0 00-3.4 3.86l4.77 6.58-1.08-8.23z"
      />
      <path
        className="st12"
        d="M83.43 36.24l-.8-1.08c-3.47-.6-7.25-4.02-10.54-9.39 0 0-.3.56-.77 1.42L78 38.06l5.43-1.82z"
      />
      <path
        className="st10"
        d="M85.72 35.59c-.62-.22-1.29-.34-2-.34-.36 0-.72-.03-1.08-.1l.8 1.08 2.28-.64z"
      />
      <path
        className="st13"
        d="M78 38.06l1.31 2.43 7.66 3.3c.65-.43 1.18-.98 1.55-1.62l-5.08-5.93L78 38.06z"
      />
      <path
        className="st9"
        d="M88.51 42.17c.38-.65.6-1.39.6-2.17 0-2-1.4-3.71-3.4-4.41l-2.29.65 5.09 5.93z"
      />
      <path
        className="st1"
        d="M79.28 40.48l2.18 4.13c.74.09 1.49.14 2.25.14 1.22 0 2.35-.36 3.25-.95l-7.66-3.3-.02-.02z"
      />
      <path className="st12" d="M78 38.06L75.78 38.82 79.28 40.48z" />
      <path
        className="st4"
        d="M40.95 33.68l-4.19 8.94c.84.42 1.7.78 2.57 1.08l2.09-9.73a7.39 7.39 0 01-.47-.29z"
      />
      <path className="st9" d="M76.79 5.16l-4.65-.11c-.02.01-.04.03-.06.04l4.29 1.45.42-1.38z" />
      <path className="st10" d="M77.66 2.25c-1.9.64-3.75 1.57-5.52 2.8l4.65.11.87-2.91z" />
      <g>
        <path
          className="st9"
          d="M120.11 14.56c.37-.37.87-.55 1.51-.55.92 0 1.69.25 2.3.77.61.51.91 1.23.91 2.15 0 .51-.1.97-.29 1.38l-8.32 18.04c-.35.67-.75 1.17-1.19 1.51-.45.33-1.03.5-1.77.5s-1.32-.17-1.75-.5c-.43-.33-.82-.87-1.17-1.6l-7.94-17.7c-.13-.22-.24-.5-.34-.84-.1-.33-.14-.64-.14-.93 0-.8.27-1.46.81-1.98.54-.53 1.26-.79 2.15-.79.83 0 1.44.21 1.84.64.4.43.68.84.84 1.22l5.84 14.07 5.84-14.07c.21-.52.51-.96.87-1.32zM134.68 6.06c.6.54.9 1.32.9 2.34 0 1.09-.3 1.87-.9 2.34-.61.48-1.37.72-2.3.72-.89 0-1.63-.26-2.22-.76-.59-.51-.89-1.28-.89-2.3 0-.99.29-1.76.86-2.32.57-.56 1.32-.84 2.25-.84.93.01 1.69.28 2.3.82zm-4.45 8.78c.54-.56 1.24-.84 2.11-.84.86 0 1.56.28 2.1.84.54.56.81 1.24.81 2.03v13.92c0 .64.09 1.17.26 1.6.18.43.5.64.98.64.54 0 .92.24 1.15.72.22.48.33.99.33 1.53 0 .92-.28 1.67-.84 2.23-.56.56-1.39.83-2.51.83-1.62 0-2.9-.55-3.83-1.65-.92-1.1-1.38-2.94-1.38-5.52v-14.3c.01-.79.28-1.47.82-2.03zM160.17 6.16c.58-.54 1.28-.81 2.11-.81.82 0 1.52.27 2.08.81s.84 1.23.84 2.06v27.07c0 1.08-.27 1.87-.81 2.34-.54.48-1.27.72-2.2.72-.96 0-1.68-.28-2.16-.83-.48-.56-.72-1.22-.72-1.98v-1.96c-.8 1.66-1.85 2.95-3.16 3.88-1.31.92-2.91 1.38-4.79 1.38-1.43 0-2.8-.28-4.09-.84-1.29-.56-2.43-1.38-3.42-2.46-.99-1.09-1.77-2.4-2.35-3.95-.57-1.55-.86-3.31-.86-5.28 0-1.98.3-3.76.88-5.33.59-1.58 1.39-2.92 2.41-4.02 1.02-1.1 2.2-1.94 3.54-2.53 1.34-.59 2.76-.88 4.25-.88 2.04 0 3.65.45 4.83 1.36 1.18.91 2.09 2.08 2.73 3.52V8.22c.03-.83.32-1.52.89-2.06zm-4.71 26.86c.78-.33 1.46-.81 2.03-1.43.57-.62 1.03-1.39 1.36-2.3.34-.91.51-1.92.51-3.04 0-2.23-.6-4.02-1.79-5.36-1.19-1.34-2.72-2.01-4.57-2.01-1.98 0-3.52.68-4.64 2.04-1.12 1.35-1.67 3.13-1.67 5.33 0 1.12.16 2.12.48 3.02.32.89.77 1.65 1.34 2.27.57.62 1.24 1.11 2.01 1.46.77.35 1.6.53 2.49.53.85-.01 1.67-.18 2.45-.51zM196.08 33.04c.48 0 .85.2 1.12.6.27.4.41.96.41 1.7 0 2.01-1.23 3.01-3.68 3.01-1.59 0-2.75-.42-3.49-1.27a5.999 5.999 0 01-1.39-2.94l-.04-.57c-.77 1.69-1.84 2.99-3.23 3.9-1.39.91-3.02 1.36-4.9 1.36-1.44 0-2.79-.29-4.06-.88a10.01 10.01 0 01-3.35-2.51c-.95-1.09-1.71-2.4-2.27-3.95-.56-1.55-.84-3.28-.84-5.19 0-1.91.3-3.66.88-5.24.59-1.58 1.39-2.93 2.39-4.04 1-1.11 2.17-1.98 3.49-2.58 1.32-.6 2.72-.91 4.19-.91 1.98 0 3.58.44 4.81 1.31 1.22.88 2.19 2.07 2.89 3.56v-1.91c0-.73.27-1.33.81-1.79.54-.46 1.26-.69 2.15-.69.89 0 1.6.23 2.13.69.53.46.79 1.06.79 1.79v14.4c0 1.44.39 2.15 1.19 2.15zm-10.91-.02c.78-.33 1.46-.81 2.03-1.43.57-.62 1.03-1.38 1.36-2.27.33-.89.5-1.9.5-3.01 0-2.23-.58-4.03-1.74-5.38-1.16-1.36-2.7-2.04-4.62-2.04-1.98 0-3.52.69-4.64 2.06-1.11 1.37-1.67 3.15-1.67 5.36 0 1.11.16 2.11.48 2.99.32.88.77 1.64 1.34 2.28.58.63 1.24 1.12 2.01 1.46.77.33 1.6.5 2.49.5.85-.02 1.68-.19 2.46-.52zM202.53 6.18c.54-.56 1.24-.83 2.1-.83.86 0 1.56.28 2.1.83.54.56.81 1.24.81 2.03v22.58c0 .64.09 1.17.26 1.6.18.43.5.64.98.64.54 0 .92.24 1.15.72.22.48.33.99.33 1.53 0 .92-.27 1.67-.83 2.23-.56.56-1.39.83-2.51.83-1.62 0-2.9-.55-3.82-1.65-.92-1.1-1.38-2.94-1.38-5.52V8.22c0-.8.27-1.48.81-2.04zM219.62 6.06c.61.54.91 1.32.91 2.34 0 1.09-.3 1.87-.91 2.34-.61.48-1.37.72-2.29.72-.89 0-1.63-.26-2.22-.76-.59-.51-.88-1.28-.88-2.3 0-.99.29-1.76.86-2.32.57-.56 1.32-.84 2.24-.84.92.01 1.69.28 2.29.82zm-4.44 8.78c.54-.56 1.24-.84 2.1-.84.86 0 1.56.28 2.1.84.54.56.81 1.24.81 2.03v13.92c0 .64.09 1.17.26 1.6.18.43.5.64.98.64.54 0 .93.24 1.15.72.22.48.33.99.33 1.53 0 .92-.28 1.67-.84 2.23-.56.56-1.4.83-2.51.83-1.62 0-2.89-.55-3.82-1.65s-1.39-2.94-1.39-5.52v-14.3c.02-.79.3-1.47.83-2.03zM227.76 14.82c.48-.54 1.22-.81 2.24-.81 1.02 0 1.76.25 2.2.77.44.51.67 1.08.67 1.72v1.48c.61-1.43 1.55-2.54 2.82-3.3 1.28-.76 2.72-1.14 4.35-1.14 2.78 0 4.93.87 6.46 2.61 1.53 1.74 2.3 4.12 2.3 7.15v12.25c0 .8-.28 1.47-.84 2.01-.56.54-1.27.81-2.13.81-.83 0-1.52-.27-2.08-.81s-.84-1.21-.84-2.01V25.34c0-2.1-.44-3.71-1.32-4.81-.88-1.1-2.09-1.65-3.66-1.65-1.59 0-2.84.57-3.73 1.7-.89 1.13-1.34 2.77-1.34 4.9v10.05c0 .8-.27 1.47-.81 2.01-.54.54-1.24.81-2.11.81-.79 0-1.48-.26-2.05-.79-.57-.53-.86-1.2-.86-2.03V16.54c.01-.61.25-1.18.73-1.72zM274.48 33.61c.22.26.45.54.67.84.22.3.33.73.33 1.27 0 .92-.31 1.59-.93 2.01-.62.41-1.23.62-1.84.62-.45 0-.83-.08-1.17-.24-.34-.16-.68-.43-1.03-.81l-7.89-8.85-2.44 2.06v5.02c0 .8-.23 1.47-.72 2.01-.48.54-1.21.81-2.2.81-.98 0-1.72-.27-2.2-.81-.48-.54-.72-1.21-.72-2.01V8.22c0-.8.23-1.48.69-2.03.46-.56 1.2-.83 2.22-.83 1.02 0 1.76.28 2.23.83.46.56.69 1.24.69 2.03v15.5l9.62-8.33c.41-.35.81-.67 1.2-.95.38-.29.84-.43 1.39-.43.83 0 1.47.27 1.91.81.45.54.67 1.14.67 1.77 0 .54-.1 1-.31 1.36-.21.37-.5.71-.88 1.03l-7.04 5.98 7.75 8.65z"
        />
      </g>
    </svg>
  );
}

export default LogoVidalink;
